import { type Translate } from 'react-admin';

import { IEmployeesCheckUploadXLSWarning } from '@/types';
import { htmlDecode } from '@/utils';

export function formatEmployeesWarnings(
  warnings: IEmployeesCheckUploadXLSWarning[],
  translate: Translate,
): string {
  return warnings
    .map(({ message, raw, itn }: IEmployeesCheckUploadXLSWarning): string => {
      if (!message.includes('employee.warnings')) {
        return htmlDecode(message);
      }

      if (typeof raw === 'number' && raw !== 0) {
        return translate(`resources.${message}`, { field: raw });
      }

      if (itn?.length) {
        const field = Array.isArray(itn) && itn.length ? itn.join(', ') : itn;

        return translate(`resources.${message}`, { field });
      }

      return translate(`resources.${message}`);
    })
    .join(' ');
}
